// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".subscription-block[data-v-e0886edc]{padding-top:134px;padding-bottom:134px;background:#fafafa}@media(max-width:991px){.subscription-block[data-v-e0886edc]{padding-top:74px;padding-bottom:74px}}.subscription-form[data-v-e0886edc]{max-width:600px;margin:0 auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
